import React, { CSSProperties } from 'react'

import s from './styles.module.scss'

import { LoginModalTypeEnum } from '../../login-modal/login.enum'
import { SetLoginModalTypeProps } from '../../login-modal/login.types'
import { Button } from '../../../atoms'

interface IHideElementButton {
  label: string
  id?: string
  onClick?: () => void
}

export interface IHideElement {
  label?: string
  styleContainer?: CSSProperties
  styleContent?: CSSProperties
  buttonProps?: IHideElementButton
  emoji?: string
  setModalType: SetLoginModalTypeProps
}

const HideElement = ({
  label,
  styleContainer,
  styleContent,
  buttonProps,
  emoji = '👌',
  setModalType,
}: IHideElement) => {
  return (
    <div className={s.hideContainer} style={styleContainer}>
      <div className={s.contentContainer} style={styleContent}>
        {label && (
          <div className={s.content}>
            <p>{emoji}</p>
            <p>
              Pour accéder{' '}
              <span style={{ fontWeight: 'bold' }}>instantanément</span> {label}
              , il suffit de vous inscrire avec votre adresse e-mail
              professionnelle
            </p>
          </div>
        )}
        {buttonProps && (
          <Button
            style={{ padding: 16, marginTop: 20 }}
            fullWidth={true}
            onClick={() =>
              buttonProps.onClick
                ? buttonProps.onClick()
                : setModalType({ type: LoginModalTypeEnum.Subscribe })
            }
            id={buttonProps.id}
          >
            {buttonProps.label}
          </Button>
        )}
      </div>
    </div>
  )
}

export default HideElement
